import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet-async";

import { theme } from "../theme";

import {
  FaWhatsapp,
  FaEnvelope,
  FaFacebook,
  FaPhone,
  FaUser,
} from "react-icons/fa";

import { TbBrandTiktok } from "react-icons/tb";
import { useTranslation } from "react-i18next";


const Container = styled.div`

  color: ${theme.colors.primary};

  min-height: 70vh;

  padding: clamp(1.25rem, 4vw, 2.5rem);

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: center;

  text-align: center;

  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;

`;



const Title = styled.h1`

  font-size: clamp(1.75rem, 5vw, 3rem);

  margin-bottom: 1.5rem;

  color: ${theme.colors.primary};

`;



const LocationText = styled.div`

  font-size: clamp(1rem, 3vw, 1.3rem);

  line-height: 1.6;

  margin-bottom: 2rem;

  font-weight: 600;


  address {

    font-style: normal;

  }

`;



const ContactInfo = styled.div`

  width: fit-content;

  max-width: 100%;

  font-size: clamp(1rem, 3vw, 1.4rem);

  line-height: 1.5;

  display: flex;

  flex-direction: column;

  gap: 1.2rem;

  margin: 0 auto;

`;



const ContactItem = styled.div`

  display: flex;

  align-items: center;

  gap: 3rem;

  color: ${theme.colors.primary};

`;



const Icon = styled.div`

  display:flex;

  align-items:center;

  justify-content:center;

  width:2.5rem;

  min-width:2.5rem;

  font-size:2rem;

  color:${theme.colors.primary};

`;


const LinkText = styled.a`

  color: ${theme.colors.primary};

  text-decoration: none;


  &:hover {

    text-decoration: underline;

  }

`;




const Contacts: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (

    <>

      <Helmet>

        <title>
          {t("contact.seoTitle")}
        </title>


        <meta

          name="description"

          content={t("contact.seoDescription")}

        />


        <meta

          name="keywords"

          content="Best Rijschool Oost-Souburg, rijschool Oost-Souburg, rijlessen Zeeland, autorijschool, rijbewijs halen, rijinstructeur"

        />

      </Helmet>




      <Container>



        <Title>

          {t("contact.title")}

        </Title>



<LocationText>

  <strong>
    Best Rijschool
  </strong>


  <address>

    Platanenstraat 2<br />

    4388 PC Oost-Souburg<br />

    {t("contact.country")}

  </address>

  <LinkText
href="https://www.google.com/maps/search/?api=1&query=Platanenstraat+2+4388+PC+Oost-Souburg"
target="_blank"
rel="noopener noreferrer"
>
{t("contact.location")}
</LinkText>


  <br />
  <br />
  <br />


  {t("contact.intro")}


  <br /><br />


  {t("contact.guidance")}


  <br /><br />


  {t("contact.active")}

  <br />

  Oost-Souburg • Vlissingen • Middelburg

  {t("contact.area")}
  <br />
  <br />


</LocationText>







        <ContactInfo>



          <ContactItem>

            <Icon>

              <FaUser />

            </Icon>


            <span>

              {i18n.language === "ar" ? "مدرب القيادة: جانكين شيخو" : t("contact.trainer")}

            </span>


          </ContactItem>





          <ContactItem>

            <Icon>

              <FaPhone />

            </Icon>


            <div>


              <LinkText href="tel:0684629633">

                0684629633

              </LinkText>


              {" - "}


              <LinkText href="tel:0628570565">

                0628570565

              </LinkText>


            </div>


          </ContactItem>






          <ContactItem>


            <Icon>

              <FaWhatsapp />

            </Icon>



            <LinkText

              href="https://wa.me/31684629633"

              target="_blank"

              rel="noopener noreferrer"

            >

              {t("contact.whatsapp")}

            </LinkText>



          </ContactItem>







          <ContactItem>


            <Icon>

              <FaEnvelope />

            </Icon>



            <LinkText

              href="mailto:best.rijschool@gmail.com"

            >

              best.rijschool@gmail.com

            </LinkText>



          </ContactItem>







          <ContactItem>


            <Icon>

              <FaFacebook />

            </Icon>




            <LinkText

              href="https://www.facebook.com/profile.php?id=61561621694605"

              target="_blank"

              rel="noopener noreferrer"

            >

              {t("contact.facebook")}

            </LinkText>




          </ContactItem>








          <ContactItem>


            <Icon>

              <TbBrandTiktok />

            </Icon>




            <LinkText

              href="https://www.tiktok.com/@best.rijschool"

              target="_blank"

              rel="noopener noreferrer"

            >

              {t("contact.tiktok")}

            </LinkText>



          </ContactItem>





        </ContactInfo>



      </Container>


    </>

  );

};



export default Contacts;
